export default class Knowledge {

  static doNumerals = (type, num) => {
    // <MenuItem value=''>--- ---</MenuItem>
    // <MenuItem value='normal'>1. 2. 3. 4. 5.</MenuItem>
    // <MenuItem value='roman'>I. II. III. IV. V.</MenuItem>
    // <MenuItem value='romansmall'>i. ii. iii. iv. v.</MenuItem>
    // <MenuItem value='alphabet'>A. B. C. D. E.</MenuItem>
    // <MenuItem value='alphabetsmall'>a. b. c. d. e.</MenuItem>
    if (type === 'roman' || type === 'romansmall') {
      let n = this.romanize(num);
      if (type === 'roman') return n;
      if (type === 'romansmall') return n.toLowerCase();
    } else {
      if (type === 'alphabet' || type === 'alphabetsmall') {
        let n = this.columnToLetter(num);
        if (type === 'alphabet') return n;
        if (type === 'alphabetsmall') return n.toLowerCase();
      } else {
        return num;
      }
    }
  };

  static columnToLetter(num) {
    var temp, letter = '';
    while (num > 0)
    {
      temp = (num - 1) % 26;
      letter = String.fromCharCode(temp + 65) + letter;
      num = (num - temp - 1) / 26;
    }
    return letter;
  };

  static romanize = (num) => {
    if (isNaN(num)) return NaN;

    var digits = String(+num).split(""),
      key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
             "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
             "","I","II","III","IV","V","VI","VII","VIII","IX"],
      roman = "",
      i = 3;
  while (i--)
      roman = (key[+digits.pop() + (i * 10)] || "") + roman;
  return Array(+digits.join("") + 1).join("M") + roman;
  };
}
